<template>

    <section class="orders">
        <div class="container">

            <div class="box-title">
                <h1>Mis pedidos</h1>
                <p>Ultimos 10 pedidos realizados</p>
            </div>

            <div class="row">
                <div class="col-lg-12">

                    <div class="panel box-pedido" v-for="order in orders" :key="order.id">

                        <h1>Pedido #{{order.ID}}</h1>
                        <h4>{{order.ORDER_DATE}}</h4>

                        <div class="row">

                            <div class="col-md-4">
                                <h2>Datos</h2>
                                <ul class="detalle">
                                    <li>
                                        <span>Vendedor:</span> {{order.NOMBRE_VEN}}
                                    </li>
                                    <li>
                                        <span>Cliente:</span> {{order.RAZON_SOCI}}
                                    </li>
                                    <li>
                                        <span>CUIT:</span> {{order.CUIT}}
                                    </li>

                                    <li>
                                        <b>Entrega:</b> {{order.DIRECCION_ENTREGA}}
                                    </li>

                                    <li>
                                        <span>Localidad:</span> {{order.LOCALIDAD_ENTREGA}}
                                    </li>

                                     <li>
                                        <span>Provincia:</span> {{order.PROVINCIA_ENTREGA}}
                                    </li>

                                </ul>
                            </div>

                            <div class="col-md-4">
                                <h2>Estado del pedido</h2>
                                <ul class="detalle">
                                    <li>
                                        {{statusText(order)}}
                                    </li>
                                </ul>
                            </div>

                            <div class="col-md-4">
                                <h2>Resumen de compra</h2>
                                <ul class="detalle">
                                    <li>
                                      <div class="btn-box">
                                      <a href="#" @click.prevent="pageDetail(order)" class="btn-default">
                                        <span>VER DETALLE DEL PEDIDO</span>
                                      </a>
                                      </div>
                                    </li>
                                    <li style="display:none">
                                        <span>Subtotal:</span> $ {{order.TOTAL}}
                                    </li>
                                    <li v-if="order.descuento>0" style="display:none">
                                        <span>Descuento:</span> $ {{order.descuento}}
                                    </li>
                                    <li style="display:none">
                                        <span>TOTAL:</span> <span class="highlight">$ {{order.TOTAL}}</span>
                                    </li>
                                </ul>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>
    </section>

</template>

<script>

    import Api from '@/Api'
    import { mapGetters } from 'vuex';

    export default {
        name: "MyOrdersPage",
        data(){
            return {
                orders:[]
            }
        },
        computed: {
        ...mapGetters(['user']),

        },
        methods:{
          pageDetail(order)
          {
            this.$router.push({name: 'MyOrdersDetail',params:{id:order.ID}});
          },
          statusText(order){
            if (order.ORDER_STATUS===1) return "PENDIENTE AUTORIZACION";
            if (order.ORDER_STATUS===2) return "PENDIENTE DE ARMADO";
            if (order.ORDER_STATUS===3) return "EN ARMADO";
            if (order.ORDER_STATUS===4) return "FACTURADO";
            if (order.ORDER_STATUS===5) return "PENDIENTE ENVIO";
            if (order.ORDER_STATUS===6) return "EN VIAJE";
            if (order.ORDER_STATUS===8) return "RECHAZADO";
            if (order.ORDER_STATUS===9) return "CANCELADO";
            if (order.ORDER_STATUS===7) return "EN TRANSITO";
            return "--INTERNO---";
          }
        },
        mounted(){

            $('body').removeClass();

            Api().get('orders').then(data=>{ // +user.user_id
                if (data.data.status===1){
                    this.orders = data.data.data;
                }else{
                    this.orders = [];
                }

            }).catch(err=>{

            });

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MyOrdersPage.vue